/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
:host {
  display: flex;
  writing-mode: horizontal-tb
}

.list {
  margin: 0px;
  display: flex;
  list-style-type: none;
  padding: 0px
}

.list-item {
  margin: 0px;
  display: flex;
  padding: 0px
}

:host([scale=s]) .chevron, :host([scale=s]) .page, :host([scale=s]) .ellipsis {
  block-size: 1.5rem;
  padding-inline: 0.25rem;
  font-size: var(--calcite-font-size--2);
  line-height: 1rem;
  min-inline-size: 1.5rem
}

:host([scale=m]) .chevron, :host([scale=m]) .page, :host([scale=m]) .ellipsis {
  block-size: 2rem;
  padding-inline: 0.5rem;
  font-size: var(--calcite-font-size--1);
  line-height: 1rem;
  min-inline-size: 2rem
}

:host([scale=l]) .chevron, :host([scale=l]) .page, :host([scale=l]) .ellipsis {
  block-size: 2.75rem;
  font-size: var(--calcite-font-size-0);
  line-height: 1.25rem;
  min-inline-size: 2.75rem
}
:host([scale=l]) .chevron {
  padding-inline: 0.625rem
}
:host([scale=l]) .page, :host([scale=l]) .ellipsis {
  padding-inline: 0.75rem
}

:host button {
  outline-color: transparent
}
:host button:focus {
  outline: 2px solid var(--calcite-ui-focus-color, var(--calcite-color-brand));
  outline-offset: calc(
            -2px *
            calc(
              1 -
              2 * clamp(
                0,
                var(--calcite-offset-invert-focus),
                1
              )
            )
          )
}

.chevron,
.page,
.ellipsis {
  margin: 0px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  border-style: none;
  --tw-border-opacity: 0;
  background-color: transparent;
  padding: 0px;
  vertical-align: baseline;
  font-family: inherit;
  font-size: var(--calcite-font-size-0);
  line-height: 1.25rem;
  color: var(--calcite-color-text-3)
}

.chevron,
.page {
  cursor: pointer;
  border-block: 2px solid transparent
}
.chevron:hover,
.page:hover {
  color: var(--calcite-color-text-1);
  transition: background-color, block-size, border-color, box-shadow, color, inset-block-end, inset-block-start, inset-inline-end, inset-inline-start inset-size, opacity, outline-color, transform var(--calcite-animation-timing) ease-in-out 0s, outline 0s, outline-offset 0s
}

.page:hover {
  border-block-end-color: var(--calcite-color-border-2)
}
.page.selected {
  font-weight: var(--calcite-font-weight-medium);
  color: var(--calcite-color-text-1);
  border-block-end-color: var(--calcite-color-brand)
}

.chevron:hover {
  background-color: var(--calcite-color-foreground-2);
  color: var(--calcite-color-brand)
}
.chevron:active {
  background-color: var(--calcite-color-foreground-3)
}
.chevron.disabled {
  pointer-events: none;
  background-color: transparent
}
.chevron.disabled > calcite-icon {
  opacity: var(--calcite-opacity-disabled)
}

:host([hidden]) {
  display: none
}

[hidden] {
  display: none
}